var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
    '--platform-main-color': _vm.platformMainColor,
    '--platform-accent-color': _vm.platformAccentColor,
  }),attrs:{"id":"app"}},[(!_vm.loadedStatus)?_c('appLoader'):_c(_vm.layout,{tag:"component"},[_c('keep-alive',{attrs:{"include":"dashboard"}},[_c('router-view')],1)],1),(_vm.openTimerWarning)?_c('timer-warning'):_vm._e(),_c('vue-confirm-dialog'),_c('plug')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }